import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import RealtimeTracking from './components/RealtimeTracking';
import CTASection from './components/CTASection';

const homepageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '911爆料网',
  url: 'http://baoliaowang.cn/',
  description: '911爆料网最新地址发布页，专为吃瓜群众准备的实时黑料追踪站。网红翻车、塌房现场、明星私下猛料每日更新，不遗漏任何一个网络大瓜。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'http://baoliaowang.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <SEO
        title="吃瓜黑料第一站"
        description="911爆料网最新地址发布页，专为吃瓜群众准备的实时黑料追踪站。网红翻车、塌房现场、明星私下猛料每日更新，不遗漏任何一个网络大瓜。"
        keywords="911爆料网,911爆料网最新地址,911爆料网吃瓜黑料,911吃瓜爆料网,911爆料吃瓜网,网红翻车,塌房现场,实时爆料,吃瓜第一站"
        canonicalUrl="http://baoliaowang.cn/"
        schema={homepageSchema}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <RealtimeTracking />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}